module.exports = __webpack_public_path__ + "img/industrial-truck.cde7fad.png";